export default __webpack_public_path__ + "static/media/img-slider-lh-job-sale-2.43ab8b24.png";